;(function (angular) {
   'use strict'

   angular.module('azure.validation', [])
})(angular)
